export enum ERoutes {
  splash = '/',
  main = '/main',
  leaderboard = '/leaderboard',
  competitionMode = '/competition-mode',
  userProfile = '/user-profile',
  connectByTelegramOAuth = '/connect-by-telegram-oauth',
  quizzStart = '/quizz-start',
  quizz = '/quizz',
  dailyQuests = '/daily-quests',
  referral = '/referral',
  gameModes = '/game-modes',
  generalMode = '/general-mode',
  competitionRules = '/competition-rules',
  generalRules = '/general-rules',
  finalizeCompetition = '/finalize-competition',
  trainingMode = '/training-mode',
  trainingRules = '/training-rules',
}
